module.exports = __webpack_public_path__ + "img/ihrm2.06082575.png";